import type { ApiClient } from '@travel/api-client';

import { MONTEROSA_API_TIMEOUT } from 'store/utils';

import type { ServiceConditionResponse } from 'ServiceCondition-Types';

export const fetchServiceConditions = (http: ApiClient): Promise<ServiceConditionResponse> =>
  http.get('/monterosa-api-dp/dp/jrdp/service-conditions', {
    ignoreCommonErrorHandler: true,
    timeout: MONTEROSA_API_TIMEOUT,
  });
